import { Component, type ErrorInfo, type ReactNode } from "react";

import ErrorPage from "@/components/ui/ErrorPage";

type AppErrorBoundaryProps = {
  children: ReactNode;
};

type AppErrorBoundaryState = {
  error?: Error;
};

export default class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = {};

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught application error", error, errorInfo);
  }

  private retry = () => {
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return <ErrorPage error={this.state.error} onRetry={this.retry} />;
    }

    return this.props.children;
  }
}
